<template>
    <div>
        <input-validate
            type="text"
            title="Bank name"
            name="bank_name"
            v-model="bank_name"
            placeholder="Enter bank name"
            v-validate="'required'"
            data-vv-value-path="innerValue"
            data-vv-validate-on="blur"
            :error="errors.first('bank_name')"
            :is-title-latent="true"
        ></input-validate>
        <input-validate
            type="text"
            title="IFSC"
            name="ifsc"
            v-model="ifsc"
            placeholder="Enter ifsc with a length of 11 digits"
            v-validate="'required|ifsc'"
            data-vv-value-path="innerValue"
            data-vv-validate-on="blur"
            :error="errors.first('ifsc')"
            :is-title-latent="true"
        ></input-validate>
        <input-validate
            type="text"
            title="Name"
            name="name"
            v-model="name"
            placeholder="Enter your name"
            v-validate="'required'"
            data-vv-value-path="innerValue"
            data-vv-validate-on="blur"
            :error="errors.first('name')"
            :is-title-latent="true"
        ></input-validate>
        <input-validate
            type="text"
            title="Account"
            name="account"
            v-model="bank_account"
            placeholder="Enter your bank account"
            v-validate="'required'"
            data-vv-value-path="innerValue"
            data-vv-validate-on="blur"
            :error="errors.first('account')"
            :is-title-latent="true"
        ></input-validate>
        <md-button style="margin-top: 0.5rem;" type="primary" :loading="loading" :disabled="loading" @click="submit_payment">Confirm</md-button>
    </div>
</template>

<script>
import { Validator } from "vee-validate";
import inputValidate from "@/components/input-validate";
import { editbank, addbank } from '@/request/api'


Validator.extend("ifsc", {
    getMessage: field => `${field} value do not meet right format`,
    validate: value => /^[A-Za-z]{4}\d{7}$/.test(value)
});

export default {
    name: 'bankform',
    components: {
        inputValidate
    },
    props: {
        bank: {
            type: Object,
            default: {}
        },
        edit: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false,
            name: "",
            bank_account: "",
            bank_name: "",
            ifsc: "",
            id: ""
        }
    },
    watch: {
        bank(newval) {
            if(newval) {
                this.name = this.bank.name;
                this.bank_account = this.bank.bank_account;
                this.bank_name = this.bank.bank_name;
                this.ifsc = this.bank.ifsc;
                this.id = this.bank.id;
            }
        }
    },
    created() {
        if(this.bank) {
            this.name = this.bank.name;
            this.bank_account = this.bank.bank_account;
            this.bank_name = this.bank.bank_name;
            this.ifsc = this.bank.ifsc;
            this.id = this.bank.id;
        }
    },
    methods: {
        submit_payment() {
            let that = this;
            that.loading = true;
            const success = this.$validator.validateAll().then(res=>{
                if(res) {
                    let formdata = {
                        name: that.name,
                        bank_account: that.bank_account,
                        bank_name: that.bank_name,
                        ifsc: that.ifsc
                    }
                    if(this.id !== "") {
                        formdata.id = this.id;
                    }
                    if(this.edit) {
                        editbank(formdata).then(res=>{
                            that.loading = false;
                            if(res.code === 200) {
                                that.$toast.succeed("Successfully");
                                setTimeout(() => {
                                    that.$router.push('/banks');
                                }, 2000);
                            } else {
                                that.$toast.failed(res.errmsg);
                            }
                        }).catch(error=> {
                            that.loading = false;
                            that.$toast.failed("fail");
                        })
                    } else {
                        addbank(formdata).then(res=>{
                            that.loading = false;
                            if(res.code === 200) {
                                that.$toast.succeed("Successfully");
                                setTimeout(() => {
                                    that.$router.push('/banks');
                                }, 3000);
                            } else {
                                that.$toast.failed(res.errmsg);
                            }
                        }).catch(error=> {
                            that.loading = false;
                            that.$toast.failed("fail");
                        })
                    }
                } else {
                    that.loading = false;
                    that.$toast.failed("error");
                    return
                }
            })
        },
    }
}

</script>
<style scoped>
.upi-tips {
    margin-top: 0.3rem;
    color: #46ac2a;
    font-size: 0.20rem;
}
</style>



// WEBPACK FOOTER //
// src/views/my/forms/bankform.vue